import {
  Authenticator,
  Theme,
  ThemeProvider,
  useTheme
} from '@aws-amplify/ui-react'
import React from 'react'
// import BarGraph from '../../assets/bar-graph.svg?react'
// import BulletList from '../../assets/bullet-list.svg?react'
// import PieChart from '../../assets/pie-chart.svg?react'
// import ChatBubbleLeftRight from '../../assets/speech-bubble-large.svg?react'
// import VideoPlayer from '../../assets/video-player.svg?react'
import styles from './styled-authenticator.module.css'

interface Props {
  initialState?: 'signIn' | 'signUp' | 'forgotPassword' | undefined
  services?: any
  components?: any
  formFields?: any
  children: React.ReactNode
}

const StyledAuthenticator: React.FC<Props> = ({
  initialState,
  services,
  components,
  formFields,
  children,
}) => {

  const { tokens } = useTheme()
  const theme: Theme = {
    name: 'Documate Theme',
    tokens: {
      components: {
        authenticator: {
          router: {
            boxShadow: `0 0 16px ${tokens.colors.overlay['10']}`,
            borderWidth: '0',
          },
          form: {
            padding: `${tokens.space.medium} ${tokens.space.xl} ${tokens.space.medium}`,
          },
        },
        button: {
          primary: {
            backgroundColor: '#EB5829',
          },
          link: {
            color: '#EB5829',
          },
        },
        fieldcontrol: {
          _focus: {
            boxShadow: `0 0 0 2px ${tokens.colors.purple['60']}`,
          },
        },
        tabs: {
          item: {
            color: tokens.colors.neutral['80'],
            _active: {
              borderColor: '#EB5829',
              color: '#EB5829',
            },
          },
        },
      },
    },
  }

  return <ThemeProvider theme={theme}>
    <div className={styles.wrapper}>
      <Authenticator
        services={services}
        components={components}
        formFields={formFields}
        initialState={initialState}
      >
        {children}
      </Authenticator>

      {/* <div className={styles.svgIconWrapper} >
        <PieChart />
        <VideoPlayer />
        <BulletList />
        <BarGraph />
        <ChatBubbleLeftRight />
      </div> */}
    </div>
  </ThemeProvider>
}

export default StyledAuthenticator
